import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

import { USER_MGMT_CNST } from '../constants/proj.cnst';
import { UM_TABLE_CNST } from '../constants/table.cnst';

import { Subscription } from 'rxjs';

import { AuthenticationService } from '../modules/authentication/services/authentication.service';
import { EnvService } from '../services/env.service';
import { HttpService } from '../services/http.service';
import { UtilsService } from '../services/utils.service';
import { AppStateService } from './app-state.service';
import { isNullOrUndefined } from '../shared/common-utils';
import { isPlatformBrowser } from '@angular/common';
import { parseUserPermissions } from '../shared/permission.util';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  userPermissions: any = {};
  subscriptions : Subscription[] = [];
  private isBrowser: boolean;


  constructor(
    private appStateSrv: AppStateService,
    private authSrv : AuthenticationService,
    private httpSrv : HttpService,
    private utilSrv : UtilsService,
    private envSrv : EnvService,
    private router : Router,
    @Inject(PLATFORM_ID) private platformId: object
    ) {

    // const userPermissionsRef = this.appStateSrv.userPermissionsRef.subscribe((response: any) => {
    //   this.userPermissions = { ...response };
    //   userPermissionsRef.unsubscribe();
    // })

    // this.subscriptions.push(userPermissionsRef);
    this.isBrowser = isPlatformBrowser(this.platformId);

    if(this.isBrowser) {
      this.userPermissions = localStorage.getItem('userPermissions')
    }

  }

  getUserData(){
    return {
      userId:"Harsh.Pensi@gapac.com" ,
      accessToken: "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJqYW5lZG9lIiwiaXNzIjoidmFzc2FyIiwiZXhwIjoxNjI5MzQwODU3LCJ0bXAiOjE2Mjg0NzY4NTcwNzR9.KDMOS2evjLJ7nVw3NTSDjr9RKRC3XB9rqX99oUFisJU",
    }
  }

  addOptionsToTableData(tableData: any[], resourceName?: string, tableName?: string) {
    if(resourceName) {
      let allowedOperations = this.getListOfOperationsToBeShownInTable(resourceName);
  
      let { LIST_NAME_MAPPING, CUSTOMER_ADMIN_ROLE, CUSTOMER_SERVICE_EXECUTIVE } = USER_MGMT_CNST;
      let userPermissions = this.appStateSrv.getUserPermissions();
  
      let isRoleTable = !isNullOrUndefined(tableName) &&
        (tableName === LIST_NAME_MAPPING.PROFILE_LIST ||
          tableName === LIST_NAME_MAPPING.PROFILE_CUSTOMER_LIST);
  
      if (isRoleTable) {
        return this.processTableData(tableData, allowedOperations, userPermissions, CUSTOMER_ADMIN_ROLE, CUSTOMER_SERVICE_EXECUTIVE);
      } else {
        return this.getModifiedTableDataWithActions(tableData, allowedOperations);
      }
    }
    return false;
  }
  
  processTableData(tableData: any[], allowedOperations: any, userPermissions: any, CUSTOMER_ADMIN_ROLE: any, CUSTOMER_SERVICE_EXECUTIVE: any):any {
    if (this.utilSrv.isObjectNotNullAndEmpty(userPermissions)) {
      let userMgmtPermissions = userPermissions[USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION];
  
      if (this.utilSrv.isObjectNotNullAndEmpty(userMgmtPermissions)) {
        let { roleName } = userMgmtPermissions;
  
        let isUserCustomerAdminOrCSE = roleName === CUSTOMER_ADMIN_ROLE || roleName === CUSTOMER_SERVICE_EXECUTIVE;
  
        if (!isUserCustomerAdminOrCSE) {
          return tableData.map(item => {
            let isCustomerSpecificRole = !isNullOrUndefined(item['customerName']);
            let modifiedOperations = [...allowedOperations];
  
            if (isCustomerSpecificRole) {
              modifiedOperations = allowedOperations.filter((action: string) => action !== 'Edit');
            } else {
              item['customerName'] = '-';
            }
  
            return { ...item, 'options': [...modifiedOperations], 'status': item.status ? USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE : USER_MGMT_CNST.STATUS_TYPE_LIST.INACTIVE }
          });
        } else {
          return this.getModifiedTableDataWithActions(tableData, allowedOperations);
        }
      }
    }
  }

  getModifiedTableDataWithActions(tableData : any[], operations : string[]) {
    return tableData?.map(item => {
      return { ...item, 'options': [...operations], 'status': item?.status ? USER_MGMT_CNST.STATUS_TYPE_LIST.ACTIVE : USER_MGMT_CNST.STATUS_TYPE_LIST.INACTIVE }
    })
  }

  getAllowedOperationsForResource(resourceName: string) {
    if(this.isBrowser) {
      this.userPermissions = parseUserPermissions(localStorage.getItem('userPermissions'));
    } else {
      this.userPermissions = parseUserPermissions(this.appStateSrv.getUserPermissions());
    }

    if (Object.keys(this.userPermissions).length > 0) {
      return this.userPermissions[USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION]?.["resources"]?.[resourceName]?.actions
        ? this.userPermissions[USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION]["resources"][resourceName].actions
        : [];
    }
    return [];
  }

  getListOfOperationsToBeShownInTable(resourceName: string) : string[] {
    let possibleOperations = Object.keys(UM_TABLE_CNST.ES_OPTIONS);

    let allowedOperationsForResource = this.getAllowedOperationsForResource(resourceName);

    if (!isNullOrUndefined(allowedOperationsForResource)) {
      possibleOperations = possibleOperations.filter(operation => allowedOperationsForResource.indexOf(operation) !== -1);

      possibleOperations = possibleOperations.map(operation => {
        let operations = operation.split("_");
        let finalOperation: any[] = [];

        operations.forEach((op: string) => {
          op = op.substring(0, 1) + op.substring(1).toLowerCase();
          finalOperation.push(op);
        })

        return finalOperation.join("_");
      });
    }

    return possibleOperations;
  }

  setLoggedInUserInfo(loginResponse: any) {
    let { statusCode, response } = loginResponse;

    if (statusCode === 200) {

      if (!isNullOrUndefined(response)) {
        let { userDetails, promptForChangePassword = false, token } = response;

        promptForChangePassword = !promptForChangePassword;

        const { firstName, lastName, username, userId } = userDetails || {
          firstName: '',
          lastName: '',
          username: '',
          userId: '',
        };

        this.authSrv.setUserInfo({ firstName, lastName, username, userId ,promptForChangePassword}, token);

        this.appStateSrv.setPermissionsLoaded(false);
        this.appStateSrv.setInProcess(false);
        this.appStateSrv.setUserMetaInfo({});
        this.appStateSrv.setUserPermissionsRef({});
      }
    }
  }


  formatCustomerNameSearchResponse(response: any) : any[] {
    let formattedResponse: any[] = [];

    let customerIds = Object.keys(response);

    customerIds.forEach((customerId : string) => {
      let { customerName } = response[customerId];
      formattedResponse.push({customerId, customerName});
    })

    return formattedResponse;
  }

  filterCustomerTableRecordsForCustomerName(searchResults: any[], customerIds : string[]): any[] {
    return searchResults.filter(result => customerIds.indexOf(result.customerId) !== -1);
  }

  buildCustomerAttributeValues(customerAttributes : any) : any[] {

    let finalAttributes = [];

    for (let key in customerAttributes) {
      let value = customerAttributes[key];

      let config = {
        label : key,
        values : isNullOrUndefined(value) ? '' : [value]
      }

      finalAttributes.push(config);
    }
    return finalAttributes;
  }

  checkIfAllAttributesAreFilled(attributeConfig : any[]) : boolean {
    let isFilled = attributeConfig.every((attribute : any) => attribute.values !== '');
    return isFilled;
  }

  getRoleAndRedirect() {
    let allUserPermissions = this.appStateSrv.getUserPermissions();
    console.log("All user permissions ", allUserPermissions);

    //* If permissions exist and are not null or empty
    if (this.utilSrv.isObjectNotNullAndEmpty(allUserPermissions)) {
      let appName = USER_MGMT_CNST.CURRENT_USERMANAGEMENT_APPLICATION;

      if (!isNullOrUndefined(appName)) {
        let appPermissions = allUserPermissions[appName];

        if (this.utilSrv.isObjectNotNullAndEmpty(appPermissions)) {
          this.redirectBasedOnRole(appPermissions);
        } else {
          this.redirectToAppUrl();
        }
      }
    }
  }

  redirectBasedOnRole(appPermissions: any) {
    let { roleName = null } = appPermissions;

    let isUserSuperAdminOrCustAdminOrCSE = !isNullOrUndefined(roleName) && (
      roleName === USER_MGMT_CNST.CUSTOMER_ADMIN_ROLE ||
      roleName === USER_MGMT_CNST.SUPER_ADMIN ||
      roleName === USER_MGMT_CNST.CUSTOMER_SERVICE_EXECUTIVE
    );

    let redirectUrl = isUserSuperAdminOrCustAdminOrCSE
      ? this.envSrv.userMgmtRedirectUrl
      : this.envSrv.appRedirectUrl;

    this.navigateBasedOnRedirectUrl(redirectUrl);
  }

  redirectToAppUrl() {
    let redirectUrl = this.envSrv.appRedirectUrl;
    this.navigateBasedOnRedirectUrl(redirectUrl);
  }
  

  navigateBasedOnRedirectUrl(redirectUrl: string) {

    let currentRouteUrl = this.router.url;

    let isAlreadyOnSameRoute = `/${redirectUrl}` === currentRouteUrl;
    let isRouteForChangePassword = window.location.href.includes('change-password');

    console.log("Is route for change-password ", isRouteForChangePassword);

    if (!isNullOrUndefined(redirectUrl) && !isAlreadyOnSameRoute && !isRouteForChangePassword) {
      this.router.navigate([redirectUrl, { externalUrl: redirectUrl }]);
    }
  }

  areEditCustomerFormValuesModified(originalData : any, modifiedData : any) : boolean {
    let originalDataKeys = Object.keys(originalData);
    let modifiedDataKeys = Object.keys(modifiedData);

    let isModified = false;

    for (let i = 0; i < modifiedDataKeys.length; i++) {

      let modifiedValue = modifiedData[modifiedDataKeys[i]];
      let originalValue = originalData[originalDataKeys[i]];

      if (originalValue !== modifiedValue) {
        isModified = true;
        break;
      }
    }

    return isModified;
  }

  getCustomerInfoByCustomerId(options: any): Promise<any> {

    let promise = new Promise((resolve) => {
      this.httpSrv.makeGetApiCall('FETCH_CUSTOMER_ATTRIBUTES', this.envSrv.baseUrl, options).subscribe({
          next: (customerAttributes: any) => {
            resolve(customerAttributes);
          },
          complete: () => {},
          error: (err: any) => {
            console.log("Error in fetching customer attributes ", err);
            this.utilSrv.showToastMessage("Error in fetching customer attributes", "error");
            resolve({});
          }
        });
    })
    return promise;
  }

  getCustomerAdminInfoByCustomerId(options: any): Promise<any> {

    let promise = new Promise((resolve) => {
      this.httpSrv.makeGetApiCall('FETCH_CUSTOMER_ADMIN_INFO_BY_CUSTOMER_ID', this.envSrv.baseUrl, options).subscribe({
        next: (customerAdminInfo: any) => {
          resolve(customerAdminInfo);
        },
        complete: () => {},
        error: (err: any) => {
          console.log("Error in fetching customer admin info by customer id ", err);
          this.utilSrv.showToastMessage("Error in fetching customer admin info", "error");
          resolve({});
        }
      });
    });
    return promise;
  }

  buildCustomerInfoPostData(response : any) {
    let { customerName, email, primaryContact, secondaryContact, address, billingAddress } = response;
    return { customerName, email, primaryContact, secondaryContact, address, billingAddress };
  }

  getRoleInfoById(options: any): Promise<any> {
    let promise = new Promise((resolve) => {
      this.httpSrv.makeGetApiCall('GET_ROLE_INFO_BY_ID', this.envSrv.baseUrl, options).subscribe({
        next: (roleInfo: any) => {
          resolve(roleInfo);
        }, complete: () => {},
        error: (err: any) => {
          console.log("Error in fetching role info by role id ", err);
          this.utilSrv.showToastMessage("Error in fetching role info", "error");
          resolve({});
        }
      });
    });
    return promise;
  }

  fetchAllResourcesForAllAssignedAppsByCustomerId(options: any): Promise<any> {
    let promise = new Promise((resolve) => {
      this.httpSrv.makeGetApiCall('FETCH_ALL_ASSIGNED_RESOURCES_FOR_ASSIGNED_APPLICATIONS', this.envSrv.baseUrl, options).subscribe({
        next: (applicationListResponse: any) => {
          resolve(applicationListResponse);
        },
        complete: () => {},
        error: (err: any) => {
          console.log("Error in fetching assigned applications for customer", err);
          this.utilSrv.showToastMessage("Error in fetching assigned applications for customer", "error");
          resolve({});
        }
      });
    });
    return promise;
  }
}
